import React from 'react';
import CompanyLocationSelector from '../Components/CompanyLocationSelector';  // <-- Capital "C"
import trident from '../assets/odin-trident.png';
import '../dashboard/dashboard.css';
import Sidebar from '../Components/Sidebar';
import { logout } from '../auth/cookieUtils';

const Administration = () => {
  

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="dashboard-page">
      {/* Top Navbar */}
      <div className="dashboard-topbar">
        <div className="topbar-left">
          <img src={trident} alt="ODIN Logo" className="navbar-logo" />
          {/* Shared Company/Location Selector */}
          <CompanyLocationSelector />
        </div>
        <div className="topbar-center">
          <span className="page-title">Administration</span>
        </div>
        <div className="topbar-right">
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-main">
        {/* Left-Side Navbar */}
        <Sidebar />

        {/* Page Content */}
        <div className="dashboard-content">
          <h1>Administration</h1>
          <p>Welcome to the Administration page. Only users with ADMIN or SUPER_ADMIN roles can access this page.</p>
        </div>
      </div>
    </div>
  );
};

export default Administration;
